// @sheerid/jslib doesn't polyfill for IE11 currently
import 'whatwg-fetch';
import 'url-search-params-polyfill';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './index.css';
import { enableES5 } from 'immer';

// SheerID stuff
import { setOptions, overrideComponent, postVerificationSizeUpdates } from '@sheerid/jslib';
import App from './App';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepMedicalProfessionalPersonalInfoComponent } from './components/steps/StepMedicalProfessionalPersonalInfoComponent';
import { StepPendingComponent } from './components/steps/StepPending/StepPendingComponent';

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

// @ts-ignore
overrideComponent('StepMedicalProfessionalPersonalInfoComponent', StepMedicalProfessionalPersonalInfoComponent);
// @ts-ignore
overrideComponent('StepPendingComponent', StepPendingComponent);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
